module.exports = __webpack_public_path__ + "static/media/PushtimargImage7.089df699.jpg";